import React, { useState } from 'react';
import { Button, Divider, FormControl, List, ListItem, ListItemText, MenuItem, Popover, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
export var ExportFormatType;
(function (ExportFormatType) {
    ExportFormatType["CSV"] = "csv";
    ExportFormatType["XLS"] = "xls";
    ExportFormatType["XLSX"] = "xlsx";
})(ExportFormatType || (ExportFormatType = {}));
export var ExportDelimiter;
(function (ExportDelimiter) {
    ExportDelimiter["COMMA"] = ",";
    ExportDelimiter["SEMICOLON"] = ";";
})(ExportDelimiter || (ExportDelimiter = {}));
export var ExportRowsType;
(function (ExportRowsType) {
    ExportRowsType["ALL"] = "all";
    ExportRowsType["VISIBLE_ONLY"] = "visible";
    ExportRowsType["HEADERS_ONLY"] = "headers";
})(ExportRowsType || (ExportRowsType = {}));
export var ExportColumnsType;
(function (ExportColumnsType) {
    ExportColumnsType["ALL"] = "all";
    ExportColumnsType["VISIBLE_ONLY"] = "visible";
    ExportColumnsType["REQUIRED_FOR_IMPORT"] = "required-for-import";
})(ExportColumnsType || (ExportColumnsType = {}));
export var ListExportPopover = function (_a) {
    var anchorEl = _a.anchorEl, onClose = _a.onClose, onExport = _a.onExport, listTitle = _a.listTitle, importEnabled = _a.importEnabled;
    var _b = useState(ExportRowsType.VISIBLE_ONLY), rows = _b[0], setRows = _b[1];
    var _c = useState(ExportFormatType.XLS), format = _c[0], setFormat = _c[1];
    var _d = useState(ExportDelimiter.COMMA), delimiter = _d[0], setDelimiter = _d[1];
    var _e = useState(ExportColumnsType.VISIBLE_ONLY), columns = _e[0], setColumns = _e[1];
    var t = useTranslation().t;
    var handleExport = function (e) {
        onExport({ rows: rows, delimiter: delimiter, format: format, columns: columns }, e);
    };
    var handleColumnsChange = function (e) {
        setColumns(e.target.value);
        if (format === ExportFormatType.CSV && e.target.value === ExportColumnsType.REQUIRED_FOR_IMPORT) {
            setFormat(ExportFormatType.XLS); // reset to default
        }
    };
    var handleFormatChange = function (e) {
        setFormat(e.target.value);
        if (e.target.value !== ExportFormatType.CSV) {
            setDelimiter(ExportDelimiter.COMMA); // reset to default if format is not CSV
        }
    };
    return (React.createElement(Popover, { open: true, anchorEl: anchorEl, onClose: onClose, container: document.getElementById('appContainer'), anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, transformOrigin: { vertical: 'top', horizontal: 'center' } },
        React.createElement(List, { className: "listPopover" },
            React.createElement(ListItem, null,
                React.createElement(ListItemText, { primary: t('listExport.header', { listTitle: listTitle }), className: "listPopover__header" })),
            React.createElement(Divider, null),
            React.createElement(ListItem, null,
                React.createElement(ListItemText, { primary: t('listExport.columns') }),
                React.createElement(FormControl, null,
                    React.createElement(Select, { className: "listPopover__select", value: columns, onChange: handleColumnsChange },
                        React.createElement(MenuItem, { value: ExportColumnsType.ALL }, t('listExport.allColumns')),
                        React.createElement(MenuItem, { value: ExportColumnsType.VISIBLE_ONLY }, t('listExport.visibleColumns')),
                        importEnabled ? React.createElement(MenuItem, { value: ExportColumnsType.REQUIRED_FOR_IMPORT }, t('listExport.requiredColumnsForImport')) : undefined))),
            React.createElement(ListItem, null,
                React.createElement(ListItemText, { primary: t('listExport.rows') }),
                React.createElement(FormControl, null,
                    React.createElement(Select, { className: "listPopover__select", value: rows, onChange: function (e) { return setRows(e.target.value); } },
                        React.createElement(MenuItem, { value: ExportRowsType.ALL }, t('listExport.allRows')),
                        React.createElement(MenuItem, { value: ExportRowsType.VISIBLE_ONLY }, t('listExport.visibleRows')),
                        React.createElement(MenuItem, { value: ExportRowsType.HEADERS_ONLY }, t('listExport.headersOnly'))))),
            React.createElement(ListItem, null,
                React.createElement(ListItemText, { primary: t('listExport.format') }),
                React.createElement(FormControl, null,
                    React.createElement(Select, { className: "listPopover__select", value: format, onChange: handleFormatChange },
                        columns !== ExportColumnsType.REQUIRED_FOR_IMPORT && React.createElement(MenuItem, { value: ExportFormatType.CSV }, 'CSV'),
                        React.createElement(MenuItem, { value: ExportFormatType.XLS }, "XLS"),
                        React.createElement(MenuItem, { value: ExportFormatType.XLSX }, "XLSX")))),
            format === ExportFormatType.CSV && React.createElement(ListItem, null,
                React.createElement(ListItemText, { primary: t('listExport.delimiter') }),
                React.createElement(FormControl, null,
                    React.createElement(Select, { className: "listPopover__select", value: delimiter, onChange: function (e) { return setDelimiter(e.target.value); } },
                        React.createElement(MenuItem, { value: ExportDelimiter.COMMA }, t('listExport.comma')),
                        React.createElement(MenuItem, { value: ExportDelimiter.SEMICOLON }, t('listExport.semicolon'))))),
            React.createElement(ListItem, { className: "listPopover__actionButtons" },
                React.createElement(Button, { color: "secondary", onClick: onClose }, t('listExport.cancel')),
                React.createElement(Button, { color: "primary", onClick: handleExport }, t('listExport.export'))))));
};
export default ListExportPopover;
//# sourceMappingURL=ListExportPopover.js.map